import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9faf3cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "footer-bg1",
    src: "statics/ll/img/f_bg.png"
  })
], -1))
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = { class: "footer-content-mp" }
const _hoisted_5 = { class: "footer-content-mp-top" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "statics/ll/img/f_logo.png" })
], -1))
const _hoisted_7 = { class: "footer-nav" }
const _hoisted_8 = { class: "footer-disp" }
const _hoisted_9 = { class: "footer-list row" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-1\" data-v-9faf3cfc><div class=\"row footer-list-ico\" data-v-9faf3cfc><div class=\"col-12\" data-v-9faf3cfc><img src=\"statics/ll/img/f_address.png\" data-v-9faf3cfc></div><div class=\"col-12\" data-v-9faf3cfc><img src=\"statics/ll/img/f_email.png\" data-v-9faf3cfc></div></div></div>", 1)
const _hoisted_11 = { class: "col-11 footer-list-div" }
const _hoisted_12 = { class: "row footer-list-span" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row footer-ba" }
const _hoisted_16 = { href: "http://beian.miit.gov.cn/ " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.show
                ? "地址 : 香港金钟道89号力宝中心第一座2408B房1"
                : "Address : 2408B/F, Tower One, Lippo Centre, 89 Queensway, Hongkong"), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.show
                ? "邮箱：info@dehaarossun.com"
                : "Mailbox：info@dehaarossun.com"), 1)
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goLink(1))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "首页" : "Home"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goLink(2))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "关于我们" : "About Us"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goLink(3))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "研究与创新" : "Research and Innovation"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goLink(4))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "科技前沿" : "Latest Research"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goLink(5))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "国际合作" : "International Cooperation"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goLink(6))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "新闻" : "News"), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goLink(7))),
              style: {"color":"#fffefe"}
            }, _toDisplayString(_ctx.show ? "专家委员会" : "Expert Committee"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.show
                    ? "地址 :  香港金钟道89号力宝中心第一座2408B房"
                    : "Address : 2408B/F, Tower One, Lippo Centre, 89 Queensway, Hongkong"), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.show
                    ? "邮箱：info@dehaarossun.com"
                    : "Mailbox：info@dehaarossun.com"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "col-5",
          style: _normalizeStyle(_ctx.show ? '' : 'max-width: 29.666667% ')
        }, [
          _createTextVNode(_toDisplayString(_ctx.show
              ? " ©2020 露乐健康科技股份有限公司"
              : "@2020 © Lunaler Group. All rights reserved.") + "          ", 1),
          _createElementVNode("span", null, [
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.show ? "粤ICP备17151176号-2" : ""), 1)
          ])
        ], 4)
      ])
    ])
  ]))
}